import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { EnumIdsTcPais, Tc, TcPaisUsaCodigoPostal } from '../../../core/_infrastructure/types/common';
import { PaisService } from '../../../_mantenimiento/general/paises/pais.service';
import { PaisViewModel } from '../../../_mantenimiento/general/paises/pais.types';
import { PuntoControlViewModel } from '../../../_mantenimiento/general/puntoscontrol/puntocontrol.types';
import { PuntoInspeccionService } from '../../../_mantenimiento/general/puntosinspeccion/puntoinspeccion.service';
import { PuntoControlService } from '../../../_mantenimiento/general/puntoscontrol/puntocontrol.service';
import { PuntoControlPopupComponent } from '../components/popup/puntoControl/puntoControlPopup.component';
import {
    EnumCodigosTwTcAcciones,
    EnumIdsTcEstadoSolicitud,
    EnumIdsTcTipoMedioTransporte,
    EnumIdsTcTipoPuntoInspeccion,
    EnumIdsTcTipoSolicitud,
    EnumIdsTwTcDecisionInspeccion,
    EnumIdsTwTcTipoClonacion,
    EnumIdsTwTcTipoTransbordo,
} from '../types/enum';
import { SolicitudService } from './datosbasicos.service';
import {
    ParametrosNuevaSolicitudViewModel,
    PuntoInspeccionNuevaSolicitudViewModel,
    SolicitudViewModel,
    TSolicitanteAdministrativoViewModel,
    TSolicitudAdministrativoViewModel,
    TUsuarioExternoViewModel,
    TwTransbordoViewModel,
    TwTransitoDirectoViewModel,
    TwTrasladoViewModel,
} from './datosbasicos.types';
import { EnumLabelEstadoSolicitud, EnumLabelTipoSolicitud } from '../../../_exportacion/solicitudes/types/enum';

@Component({
    selector: 'app-solicitud-edit',
    templateUrl: './solicitud-edit.component.html',
})
export class SolicitudEditComponent extends ComponentBase implements OnInit {
    @ViewChild(PuntoControlPopupComponent) private puntoControlPopupComponent: PuntoControlPopupComponent;

    readonly DEC_SUMARIA_AEROPUERTO: number = 39;
    readonly DEC_SUMARIA_PUERTO: number = 16;
    maxlenghtDecSumaria: number = this.DEC_SUMARIA_AEROPUERTO;

    editMode = false;
    editTitle = 'Nueva';
    esImportadorExtranjero: boolean | null = false;
    paisRequiredMedioTransporte: boolean | null = false;
    esPrevia = false;
    esReImportacion = false;
    campoObligatorio = true;
    campoDeclaracionSumaria = true;
    tituloTipoSolicitud: string;
    tituloEstadoSolicitud: string;
    esTraslado = false;
    esTransitoDirecto = false;
    esTransbordo = false;
    readonlyImporExtr = true;
    esClonada = false;
    esClonFinalizaTraslado = false;
    esParticionRp = false;
    esPuntoControl = false;
    esCanarias = false;
    isCanariasPifCanarias = false;
    esPredua = false;
    esPasajeros = false;
    esProductosFitosanitarios = false;
    IdPuntoInspeccion: number | null;
    IdEstadoSolicitud: number;
    IdTipoSolicitud: number;
    IdResultadoEnvioMuestrasLaboratorio: number | null;
    DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    IdPaisTraslado: number;
    IdMedioTransporteTraslado: number | null;
    IdAutoridadControl: number | null;

    IdRegistroSanitario: number | null;
    IdRegistroSanitarioImpLugarDestino: number | null;

    IdMedioTransporteTransitoDirecto: number;
    IdMedioTransporte: number;
    IdMedioTransporteTransbordo: number;
    IdTipoTransbordo: number;
    IdPuntoInspeccionTransbordo: number | null;

    IdTipoPuntoInspeccion: number | null;
    esSolicitudGrabador = false;
    usaCodigoPostalPaisImpLugarDestino = true;
    usaCodigoPostalPaisExportador = true;
    codigoTipoSolicitud: string;
    declaracionSumariaPasajeros = 'Sin REF Aduanera';

    listPais: TcPaisUsaCodigoPostal[];
    listPuntoInspeccion: Tc[];
    listMedioTransporte: Tc[];
    listAduana: Tc[];
    listUbicacion: Tc[];
    listIntervalo: Tc[];
    listPuntoInspeccionTransito: Tc[];
    listAutoridadControl: Tc[];

    idSolicitud: number;
    IdSolicitante: number | null = null;
    IdSolicitanteAdministrativo: number | null = null;
    IdGrabador: number | null = null;
    solicitante: TUsuarioExternoViewModel;

    IdPaisDestino: number | null = null;

    solicitud: SolicitudViewModel;
    pais: PaisViewModel;
    medioTransporteTraslado: Tc;
    medioTransporteTransitoDirecto: Tc;
    medioTransporteTransbordo: Tc;
    tipoTransbordo: Tc;
    pcfTransbordo: PuntoInspeccionNuevaSolicitudViewModel;
    puntoControl: PuntoControlViewModel;
    infoPuntoControl = '';
    IdPuntoControl: number | null = null;
    esAeropuerto = false;
    deshabilitarMrn = true;

    habilitarGuardar = true;
    habilitarEdicion = true;
    habilitarSolicitanteAdministrativo = false;
    habilitarBotonCambiarPIF = false;

    visibilityDatosSolicitud = false;
    visibilityResultadoInspeccion = false;
    visibilityInformeChedPPTraces = false;
    //visibilityDocumentoTransporte: boolean = false;

    visibilitySpinnerGuardar = false;
    visibilitySpinnerInformeDatos = false;
    //visibilitySpinnerInformeTransito: boolean = false;
    visibilitySpinnerInformeInspeccion = false;
    visibilitySpinnerInformeChedPPTraces = false;

    solicitudEnviada = false;
    tieneCodigoTraces = false;
    tieneLugarDestinoImpor = false;

    paramsNuevaSolicitud: ParametrosNuevaSolicitudViewModel | null;

    enviada = false;
    laHeGrabadoYo = false;

    solicitanteCambiandoPIF = false;
    esGrabador = false;

    public isCollapsedCabecera = false;
    public isCollapsedExportador = false;
    public isCollapsedTraslado = false;
    public isCollapsedTransitoDirecto = false;
    public isCollapsedSolicitante = false;
    public isCollapsedSolicitanteAdministrativo = false;
    public isCollapsedLugaresMercancia = false;
    public isCollapsedMediosTransporte = false;
    public isCollapsedDatosEnvio = false;
    public isCollapsedDatosPapel = false;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        private globalService: GlobalService,
        private paisService: PaisService,
        private puntoInspeccionService: PuntoInspeccionService,
        private puntoControlService: PuntoControlService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private navMenuService: NavMenuService,
        private solicitudService: SolicitudService,
    ) {
        super(authService, notificacionService, exceptionHandler);
        this.solicitud = new SolicitudViewModel();
    }

    ngOnInit() {
        this.esGrabador = this.isGrabador;
        this.globalService.getPuntoInspeccionByPais(EnumIdsTcPais.ID_ESPANA).subscribe(res => {
            this.listPuntoInspeccion = res;
        }); //PROVISIONALMENTE
        this.globalService.getTipoMedioTransporteSinFerrocarril().subscribe(res => {
            this.listMedioTransporte = res;
        });

        this.paramsNuevaSolicitud = new ParametrosNuevaSolicitudViewModel();
        this.paramsNuevaSolicitud = this.solicitudService.getParamsSolicitud();

        this.createForm();

        this.idSolicitud = +this.activatedRoute.snapshot.params['id'];

        //EDIT de solicitudes (tb entrarán por aqui las de Canarias con CF, ya que se guardan antes, al igual que las solicitudes 'Normales' que finalicen un Traslado con CHEDPP NO nacional)
        if (this.idSolicitud) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.visibilityDatosSolicitud = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.IMPRIMIR_DATOS_SOLICITUD).Visible;

            //Para saber si se actua como Inspector o Grabador
            let params = new HttpParams();
            params = params.append('idSolicitud', this.idSolicitud.toString());
            params = params.append('idUsuario', this.loggedInUser!.Id.toString());
            this.solicitudService.isSolicitudUsuario(params).subscribe(resultIsGrabada => {
                this.laHeGrabadoYo = resultIsGrabada;

                this.solicitudService.getSolicitud(this.idSolicitud).subscribe(result => {
                    this.navMenuService.currentSolicitudImportacion = result;

                    this.solicitud = result;

                    this.solicitudService.currentIdSolicitud = this.solicitud.Id;

                    this.globalService.getAduanaByPuntoInspeccion(this.solicitud.IdPuntoInspeccion).subscribe(res => {
                        this.listAduana = res;
                    });

                    let params = new HttpParams();
                    params = params.append('id', this.solicitud.IdPuntoInspeccion.toString());
                    params = params.append('esimportacion', 'true');
                    this.globalService.getUbicacionByPuntoInspeccion(params).subscribe(res => {
                        this.listUbicacion = res;
                    });

                    this.globalService.getIntervaloHorasByPuntoInspeccion(this.solicitud.IdPuntoInspeccion).subscribe(res => {
                        this.listIntervalo = res;
                    });

                    this.IdEstadoSolicitud = this.solicitud.IdEstadoSolicitud;
                    this.IdResultadoEnvioMuestrasLaboratorio = this.solicitud.IdResultadoEnvioMuestrasLaboratorio;
                    this.IdTipoSolicitud = this.solicitud.IdTipoSolicitud;

                    this.esCanarias = this.solicitud.TcTipoSolicitud.Id == EnumIdsTcTipoSolicitud.ID_CANARIAS;
                    this.isCanariasPifCanarias = this.solicitud.IsCanariasPifCanarias;
                    this.esTraslado = this.solicitud.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRASLADO;
                    this.esTransitoDirecto = this.solicitud.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRANSITO_DIRECTO;
                    this.esTransbordo = this.solicitud.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRANSBORDO;
                    this.esPasajeros = this.solicitud.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_PASAJEROS;
                    this.esProductosFitosanitarios = this.solicitud.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_PROD_FITOSANITARIOS;
                    this.esClonada =
                        this.solicitud.TwSolicitudJerarquia != null &&
                        this.solicitud.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                            ? true
                            : false;
                    this.esClonFinalizaTraslado =
                        this.solicitud.TwSolicitudJerarquia != null &&
                        this.solicitud.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_FINALIZA_TRASLADO
                            ? true
                            : false;
                    this.esParticionRp =
                        this.solicitud.TwSolicitudJerarquia != null &&
                        this.solicitud.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_PARTICION
                            ? true
                            : false;
                    this.tituloTipoSolicitud = this.solicitud.TcTipoSolicitud.Descripcion;
                    this.codigoTipoSolicitud = this.solicitud.TcTipoSolicitud.Codigo;
                    this.tituloEstadoSolicitud = this.solicitud.TcEstadoSolicitud.Descripcion;
                    this.DescripcionIdResultadoEnvioMuestrasLaboratorio = this.solicitud.DescripcionIdResultadoEnvioMuestrasLaboratorio;
                    this.IdSolicitante = this.solicitud.IdUsuarioSolicitante;
                    this.IdSolicitanteAdministrativo = this.solicitud.IdUsuarioSolicitanteAdministrativo;
                    this.esPredua = this.solicitud.TwTcSubTipoSolicitud != null && this.solicitud.TwTcSubTipoSolicitud.EsPreDua;
                    this.esPrevia = this.solicitud.EsPrevia;
                    this.esReImportacion = this.solicitud.EsReImportacion;
                    this.paisRequiredMedioTransporte =
                        this.solicitud.TMedioTransporte.IdMedioTransporte == EnumIdsTcTipoMedioTransporte.ID_AVION ? false : true;

                    this.enviada = this.solicitud.Codigo != null && this.solicitud.Codigo.length > 0;

                    this.esSolicitudGrabador = this.solicitud.TSolicitudAdministrativo != null;

                    if (this.esSolicitudGrabador) {
                        this.IdGrabador = this.solicitud.TSolicitudAdministrativo.IdUsuarioGrabador;

                        this.addValidator('NifSolicitanteAdministrativo', Validators.required);
                        this.addValidator('NifSolicitanteAdministrativo', CustomValidator.NIFValidator);
                        this.addValidator('RazonSocialSolicitanteAdministrativo', Validators.required);
                        this.addValidator('NumeroTelefonoSolicitanteAdministrativo', Validators.required);
                        this.addValidator('FechaRegistro', Validators.required);

                        this.removeValidators('NifSolicitante');
                    }

                    //Si es PREDUA valido Mrn y elimino validaciones
                    if (this.esPredua) {
                        this.addValidator('Mrn', Validators.required);
                        this.addValidator('Mrn', Validators.minLength(18));
                        this.addValidator('Mrn', Validators.maxLength(18));

                        this.addValidator('Nombre', Validators.required);
                        this.removeValidators('NumeroDeclaracionSumaria');
                    }

                    this.LoadTraslado();
                    this.LoadTransitoDirecto();
                    this.LoadTransbordo();

                    this.updateForm();

                    if (!this.esPredua) {
                        this.IdPuntoInspeccion = this.solicitud.IdPuntoInspeccion;
                        //this.form.patchValue({
                        //    IdPuntoInspeccion: this.paramsNuevaSolicitud!.IdPuntoInspeccion
                        //});
                        this.onSelectPuntoInspeccion();
                        //this.onSelectTipoMedioTransporte();
                    }

                    //Si es Canarias CF y PREDUA tb tengo q cargar los datos PREDUA, despues del updateForm
                    if (
                        this.esPredua &&
                        this.solicitud.TwTcSubTipoSolicitud.EsConCf &&
                        this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_BORRADOR
                    ) {
                        this.loadPreduaDatos(this.solicitud.TMedioTransporte.Mrn);
                    }

                    //Si es solicitud de CANARIAS
                    if (this.esCanarias && !this.isCanariasPifCanarias) {
                        this.form.patchValue({
                            IdPaisProcedencia: EnumIdsTcPais.ID_ESPANA,
                        });
                        this.form.controls['IdPaisProcedencia'].disable();
                    }

                    //Si es solicitud Pasajeros
                    if (this.esPasajeros) {
                        this.form.controls['NumeroDeclaracionSumaria'].disable();
                        this.removeValidators('NumeroDeclaracionSumaria');
                        this.campoDeclaracionSumaria = false;
                    }

                    //Todo:agaro. 11012021. Tránsito Directo o Transbordo
                    if (this.esTransitoDirecto || this.esTransbordo) {
                        this.form.controls['IdPaisDestino'].disable();
                        //this.form.controls['IdMedioTransporte'].disable();
                    }

                    //Si soy Grabador
                    if (this.isGrabador && this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE) {
                        this.habilitarGuardar =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD, this.solicitud.IdEstadoSolicitud).Visible &&
                            this.laHeGrabadoYo;
                        this.habilitarEdicion =
                            this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS, this.solicitud.IdEstadoSolicitud).Editable &&
                            this.laHeGrabadoYo;
                    } else {
                        this.habilitarGuardar = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD,
                            this.solicitud.IdEstadoSolicitud,
                        ).Visible;
                        this.habilitarEdicion = this.loggedInUser!.getAction(
                            EnumCodigosTwTcAcciones.MENU_DATOS_BASICOS,
                            this.solicitud.IdEstadoSolicitud,
                        ).Editable;
                    }

                    this.solicitud.VieneDePreviaAceptada = this.solicitud.TPreviaInspector?.Aceptada;

                    //Si soy Solicitante y la Solicitud está en estado de 'Borrador' y NO viene de una 'Previa Aceptada' o es 'Pre-Dua'
                    if (
                        this.isSolicitante &&
                        this.solicitud.IdEstadoSolicitud === EnumIdsTcEstadoSolicitud.ID_BORRADOR &&
                        (!this.solicitud.VieneDePreviaAceptada || this.solicitud.IsPredua)
                    ) {
                        this.habilitarBotonCambiarPIF = true;
                    }

                    //this.visibilityDocumentoTransporte = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.IMPRIMIR_DOCUMENTO_TRANSPORTE, this.solicitud.IdEstadoSolicitud, this.solicitud.IdTipoSolicitud).Visible;
                    this.visibilityResultadoInspeccion = this.loggedInUser!.getAction(
                        EnumCodigosTwTcAcciones.IMPRIMIR_RESULTADO_INSPECCION,
                        this.solicitud.IdEstadoSolicitud,
                        this.solicitud.IdTipoSolicitud,
                    ).Visible;

                    if (
                        this.solicitud.TwTraces != null &&
                        this.solicitud.TwTraces.Codigo &&
                        this.solicitud.TwInspeccion.IdDecision != EnumIdsTwTcDecisionInspeccion.NO_PROCEDE &&
                        this.solicitud.TwInspeccion.IdDecision != EnumIdsTwTcDecisionInspeccion.NO_APTO_POR_HIGIENE
                    ) {
                        this.visibilityInformeChedPPTraces = true;
                        this.tieneCodigoTraces = true;
                    }
                    //SI ES RE-IMPORTACION
                    if (this.esReImportacion) {
                        this.tituloTipoSolicitud += EnumLabelTipoSolicitud.ID_RE_IMPORTACION;
                    }
                    //SI ES PREVIA
                    if (this.esPrevia) {
                        if (
                            this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                            this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                        ) {
                            this.tituloTipoSolicitud += EnumLabelTipoSolicitud.ID_PREVIA;
                        }

                        //Si ya la ha aceptado el inspector hay que validar como si ya no fuera PREVIA
                        if (this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA && !this.enviada) {
                            this.RemoveValidationsPrevia();
                            this.campoObligatorio = false;
                        }

                        if (this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE) {
                            this.campoObligatorio = false;
                        }
                    }

                    if (!this.habilitarEdicion) {
                        //metodo para deshabilitar los controles
                        this.DisableControlsConsulta();

                        //Si soy Inspector y no tengo ya asignada la solicitud, preguntar si quiere asignarse la solicitud (para NUEVAS y EN TRAMITE)
                        if (
                            this.isInspector &&
                            this.loggedInUser!.Id != this.solicitud.IdInspector &&
                            (this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_NUEVA ||
                                this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_EN_TRAMITE)
                        ) {
                            this.confirmationService.confirm({
                                message: '¿Desea asignarse la solicitud?',
                                accept: () => {
                                    let params = new HttpParams();

                                    params = params.append('idSolicitud', this.solicitud.Id.toString());
                                    params = params.append('idUsuario', this.loggedInUser!.Id.toString());

                                    this.solicitudService.asignarSolicitud(params).subscribe({
                                        next: () => {
                                            this.addSuccessMessage('Se ha asignado la solicitud correctamente');
                                            this.ngOnInit();
                                        },
                                        error: () => {
                                            this.addErrorMessage('Ha habido un error en la asignación');
                                        },
                                    });
                                },
                            });
                        }
                    }
                });
            });

            //this.form.controls['IdPuntoInspeccion'].disable();
        } //FIN EDIT
        else {
            //ALTA

            this.enviada = false;

            //hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al
            //valor de ciertas columnas al seleccionar un elemento
            this.globalService.getAllPaisesTcUsaCodigoPostal().subscribe(res => {
                this.listPais = res;
            });

            this.IdTipoSolicitud = this.paramsNuevaSolicitud!.IdTipoSolicitud;
            this.IdEstadoSolicitud = EnumIdsTcEstadoSolicitud.ID_BORRADOR; //las altas siempre seran borradores
            this.esSolicitudGrabador = this.isGrabador;

            if (this.esSolicitudGrabador) {
                //Si es solicitud de grabador, actualizo validaciones
                this.addValidator('NifSolicitanteAdministrativo', Validators.required);
                this.addValidator('NifSolicitanteAdministrativo', CustomValidator.NIFValidator);
                this.addValidator('RazonSocialSolicitanteAdministrativo', Validators.required);
                this.addValidator('NumeroTelefonoSolicitanteAdministrativo', Validators.required);
                this.addValidator('FechaRegistro', Validators.required);
                this.removeValidators('NifSolicitante');

                this.IdGrabador = this.loggedInUser!.Id;
            } else {
                this.IdSolicitante = this.loggedInUser!.Id;
                //Cargo los datos del Solicitante
                this.solicitudService.getSolicitante(this.IdSolicitante).subscribe(s =>
                    this.form.patchValue({
                        RazonSocial: s.RazonSocial,
                        NifSolicitante: s.NifCifRazonSocial,
                        NumeroTelefono: s.NumeroTelefono,
                    }),
                );
            }

            this.esImportadorExtranjero = this.paramsNuevaSolicitud!.esNifExtranjero;

            this.esPrevia = this.paramsNuevaSolicitud!.esPrevia;
            this.esReImportacion = this.paramsNuevaSolicitud!.esReImportacion;
            this.codigoTipoSolicitud = this.paramsNuevaSolicitud!.tipoSolicitud;
            switch (this.codigoTipoSolicitud) {
                case 'N':
                    this.tituloTipoSolicitud = EnumLabelTipoSolicitud.ID_NORMAL;
                    if (this.esReImportacion) {
                        this.tituloTipoSolicitud += EnumLabelTipoSolicitud.ID_RE_IMPORTACION;
                    }
                    if (this.esPrevia) {
                        this.tituloTipoSolicitud += EnumLabelTipoSolicitud.ID_PREVIA;
                        //elimino las validaciones normales
                        this.RemoveValidationsPrevia();
                        this.campoObligatorio = false;
                    }
                    break;
                case 'P':
                    this.tituloTipoSolicitud = EnumLabelTipoSolicitud.ID_PASAJEROS;
                    if (this.esPrevia) {
                        this.tituloTipoSolicitud += EnumLabelTipoSolicitud.ID_PREVIA;
                        //elimino las validaciones normales
                        this.RemoveValidationsPrevia();
                        this.campoObligatorio = false;
                    }
                    break;
                case 'T':
                    this.tituloTipoSolicitud = EnumLabelTipoSolicitud.ID_TRASLADO;
                    this.esTraslado = true;
                    this.LoadTraslado();
                    break;
                case 'F':
                    this.tituloTipoSolicitud = EnumLabelTipoSolicitud.ID_FINES_CIENTIFICOS;
                    break;
                case 'C':
                    this.tituloTipoSolicitud = EnumLabelTipoSolicitud.ID_CANARIAS;
                    this.form.patchValue({
                        IdPaisProcedencia: EnumIdsTcPais.ID_ESPANA,
                    });

                    break;
                case 'TD':
                    this.tituloTipoSolicitud = EnumLabelTipoSolicitud.ID_TRANSITO_DIRECTO;
                    this.esTransitoDirecto = true;
                    this.LoadTransitoDirecto();
                    break;
                case 'TB':
                    this.tituloTipoSolicitud = EnumLabelTipoSolicitud.ID_TRANSBORDO;
                    this.esTransbordo = true;
                    this.LoadTransbordo();
                    break;
                case 'PF':
                    this.tituloTipoSolicitud = EnumLabelTipoSolicitud.ID_PRODUCTOS_FITOSANITARIOS;
                    if (this.esPrevia) {
                        this.tituloTipoSolicitud += EnumLabelTipoSolicitud.ID_PREVIA;
                        // Elimino las validaciones normales
                        this.RemoveValidationsPrevia();
                        this.campoObligatorio = false;
                    }
                    break;

                default:
            }

            this.tituloEstadoSolicitud = EnumLabelEstadoSolicitud.ID_BORRADOR;
            this.habilitarGuardar = this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD, EnumIdsTcEstadoSolicitud.ID_BORRADOR).Visible;

            this.esCanarias = this.paramsNuevaSolicitud!.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_CANARIAS;
            //this.isCanariasPifCanarias = this.esCanarias && this.paramsNuevaSolicitud!.isPifCanarias;
            this.esPredua = this.paramsNuevaSolicitud!.esPredua;
            this.esPasajeros = this.paramsNuevaSolicitud!.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_PASAJEROS;
            this.esProductosFitosanitarios = this.paramsNuevaSolicitud!.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_PROD_FITOSANITARIOS;

            if (!this.esPredua) {
                this.IdPuntoInspeccion = this.paramsNuevaSolicitud!.IdPuntoInspeccion;
                this.isCanariasPifCanarias = this.esCanarias && this.paramsNuevaSolicitud!.isPifCanarias;
                this.form.patchValue({
                    IdPuntoInspeccion: this.paramsNuevaSolicitud!.IdPuntoInspeccion,
                });
                this.onSelectPuntoInspeccion();
                this.onSelectTipoMedioTransporte();
            }
            //Si es PREDUA, cargo los datos con el Mrn
            if (this.esPredua) {
                //Actualizo validaciones
                this.addValidator('Mrn', Validators.required);
                this.addValidator('Mrn', Validators.minLength(18));
                this.addValidator('Mrn', Validators.maxLength(18));
                //this.removeValidators("NIF");
                this.addValidator('Nombre', Validators.required);
                this.removeValidators('NRegistro');

                this.loadPreduaDatos(this.paramsNuevaSolicitud!.Mrn);

                //Elimino la validación de Documento Aduanero ya que se cambia por el MRN
                this.removeValidators('NumeroDeclaracionSumaria');

                //Si soy Solicitante y la Solicitud está en estado de 'Borrador' y es 'Pre-DUA'
                this.habilitarBotonCambiarPIF = true;
            }

            //Si es solicitud de CANARIAS
            if (this.esCanarias && !this.isCanariasPifCanarias) {
                this.form.controls['IdPaisProcedencia'].disable();
            }

            if (this.esPasajeros || this.esProductosFitosanitarios) {
                this.form.patchValue({
                    NRegistro: 'No Registrado',
                    NumeroDeclaracionSumaria: this.declaracionSumariaPasajeros,
                });
                this.readonlyImporExtr = false;
            }

            //Si es solicitud Pasajeros
            if (this.esPasajeros) {
                this.form.controls['NumeroDeclaracionSumaria'].disable();
                this.removeValidators('NumeroDeclaracionSumaria');
                this.campoDeclaracionSumaria = false;
            }
        } //FIN ALTA

        this.form.controls['IdPuntoInspeccion'].disable();
    } // Fin ngOnInit

    private EstableceMedioTransporte(idTipoPif: number | null): void {
        //RDLF: ahora solo se establece el tipo de transporte cuando no se ha grabado uno con anterioridad
        if (this.solicitud.TMedioTransporte.IdMedioTransporte == null) {
            if (idTipoPif == EnumIdsTcTipoPuntoInspeccion.ID_AEROPUERTO) {
                this.form.patchValue({
                    IdMedioTransporte: EnumIdsTcTipoMedioTransporte.ID_AVION,
                });
                //RDLF OJO!!: si deshabilito el campo no se envia en el submit, controlar esto
                //this.form.controls['IdMedioTransporte'].disable();
            } else if (idTipoPif == EnumIdsTcTipoPuntoInspeccion.ID_PUERTO) {
                this.form.patchValue({
                    IdMedioTransporte: EnumIdsTcTipoMedioTransporte.ID_BARCO,
                });
            } else {
                this.form.patchValue({
                    IdMedioTransporte: EnumIdsTcTipoMedioTransporte.ID_VEHICULO,
                });
            }
        }
    }

    private DisableControlsConsulta(): void {
        this.form.controls['RefSolicitante'].disable();
        this.form.controls['NombreExportador'].disable();
        this.form.controls['IdPaisExportador'].disable();
        this.form.controls['CiudadExportador'].disable();
        this.form.controls['DireccionExportador'].disable();
        this.form.controls['CodigoPostalExportador'].disable();

        if (this.esTraslado) {
            this.form.controls['IdPaisTrasladoDescripcion'].disable();
        }
        if (this.esSolicitudGrabador) {
            this.form.controls['NifSolicitanteAdministrativo'].disable();
            this.form.controls['RazonSocialSolicitanteAdministrativo'].disable();
            this.form.controls['NumeroTelefonoSolicitanteAdministrativo'].disable();
            this.form.controls['FechaRegistro'].disable();
            this.form.controls['NRegistroPapel'].disable();
        }
        this.form.controls['IdPaisOrigen'].disable();
        this.form.controls['IdPaisProcedencia'].disable();
        this.form.controls['IdPaisDestino'].disable();
        this.form.controls['IdAduana'].disable();
        this.form.controls['IdUbicacion'].disable();
        this.form.controls['FechaInspeccion'].disable();
        this.form.controls['IdIntervaloHoras'].disable();
        this.form.controls['IdMedioTransporte'].disable();
        this.form.controls['IdPaisMedioTransporte'].disable();
        this.form.controls['NumeroDeclaracionSumaria'].disable();
        //this.form.controls['Mrn'].disable();
        this.form.controls['FechaLlegada'].disable();
        this.form.controls['NumeroOMI'].disable();
        this.form.controls['IdMedioTransporteTrasladoDescripcion'].disable();
        this.form.controls['IdMedioTransporteTransitoDirectoDescripcion'].disable();
        this.form.controls['IdMedioTransporteTransbordoDescripcion'].disable();
        this.form.controls['IdTipoTransbordoDescripcion'].disable();
        this.form.controls['IdPuntoInspeccionTransbordoDescripcion'].disable();

        //this.form.controls['IdAutoridadControlDescripcion'].disable();

        //this.form.controls['Id'].disable();
    }

    private RemoveValidationsPrevia(): void {
        this.removeValidators('IdPaisExportador');
        this.removeValidators('NombreExportador');
        this.removeValidators('CiudadExportador');
        this.removeValidators('IdPaisOrigen');
        this.removeValidators('IdPaisProcedencia');
        this.removeValidators('IdPaisDestino');
        this.removeValidators('IdUbicacion');
        this.removeValidators('FechaInspeccion');
        this.removeValidators('IdMedioTransporte');
        this.removeValidators('NumeroDeclaracionSumaria');
        this.removeValidators('NumeroOMI');
        this.removeValidators('DireccionExportador');

        this.removeValidators('CodigoPostalExportador');
        this.removeValidators('FechaLlegada');
        this.removeValidators('IdPaisMedioTransporte');
    }

    private LoadTraslado(): void {
        if (this.esTraslado) {
            if (this.solicitud.TwTraslado != null && this.solicitud.TwTraslado.IdPuntoControlTraslado != null) {
                this.puntoControlService.getAutoridadesControlByPuntoControl(this.solicitud.TwTraslado.IdPuntoControlTraslado!).subscribe(res => {
                    this.listAutoridadControl = res;
                });
            }

            if (this.editMode) {
                this.IdPaisTraslado = this.solicitud.TwTraslado?.IdPaisTraslado;
                this.IdPuntoControl = this.solicitud.TwTraslado?.IdPuntoControlTraslado;
                this.IdMedioTransporteTraslado = this.solicitud.TwTraslado?.IdMedioTransporteTraslado;
                this.IdAutoridadControl = this.solicitud.TwTraslado?.IdAutoridadControl;

                this.form.patchValue({
                    IdAutoridadControlDescripcion: this.solicitud.TwTraslado?.IdAutoridadControlDescripcion,
                });
            } else {
                this.IdPaisTraslado = this.paramsNuevaSolicitud!.IdPaisTraslado;
                this.IdMedioTransporteTraslado = this.paramsNuevaSolicitud!.IdMedioTransporteTraslado;

                this.paisService.getPais(this.IdPaisTraslado).subscribe(result => {
                    this.form.patchValue({
                        IdPaisTrasladoDescripcion: result.Descripcion,
                    });
                });
                this.globalService.getTipoMedioTransporteById(this.IdMedioTransporteTraslado).subscribe(result => {
                    this.form.patchValue({
                        IdMedioTransporteTrasladoDescripcion: result.Descripcion,
                    });
                });
            }
            this.paisService.getPais(this.IdPaisTraslado).subscribe(res => {
                this.pais = res;
            });
            this.globalService.getTipoMedioTransporteById(this.IdMedioTransporteTraslado!).subscribe(res => {
                this.medioTransporteTraslado = res;
            });
            this.esPuntoControl = true;
            if (
                (this.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_BORRADOR || this.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA) &&
                this.infoPuntoControl == ''
            ) {
                this.addValidator('PuntoControlPopup', Validators.required);
            }
            if (this.editMode) {
                this.infoPuntoControl =
                    this.solicitud.TwTraslado?.IdPuntoControlTrasladoDescripcion + ' - ' + this.solicitud.TwTraslado?.IdPuntoControlTrasladoLocalidad;
                this.removeValidators('PuntoControlPopup');
            }
        }
    }

    private LoadTransitoDirecto(): void {
        if (this.esTransitoDirecto) {
            this.readonlyImporExtr = false;
            if (this.editMode) {
                this.IdMedioTransporteTransitoDirecto = this.solicitud.TwTransitoDirecto.IdMedioTransporteTransitoDirecto!;
                this.globalService.getTipoMedioTransporteById(this.solicitud.TwTransitoDirecto.IdMedioTransporteTransitoDirecto!).subscribe(res => {
                    this.medioTransporteTransitoDirecto = res;
                });

                this.IdPaisDestino = this.solicitud.TLugarMercancia.IdPaisDestino;
                //this.IdMedioTransporte = this.solicitud.TMedioTransporte.IdMedioTransporte!;
                this.form.patchValue({
                    IdPaisDestino: this.solicitud.TLugarMercancia.IdPaisDestino,
                });
            } else {
                this.form.patchValue({
                    IdPaisDestino: this.paramsNuevaSolicitud!.IdPaisTransitoDirecto,
                    IdMedioTransporteTransitoDirecto: this.paramsNuevaSolicitud!.IdMedioTransporteTransitoDirecto,
                });

                this.IdPaisDestino = this.paramsNuevaSolicitud!.IdPaisTransitoDirecto;
                this.IdMedioTransporteTransitoDirecto = this.paramsNuevaSolicitud!.IdMedioTransporteTransitoDirecto;
                this.globalService.getTipoMedioTransporteById(this.paramsNuevaSolicitud!.IdMedioTransporteTransitoDirecto).subscribe(res => {
                    this.medioTransporteTransitoDirecto = res;
                });

                this.form.controls['IdPaisDestino'].disable();
                this.form.controls['IdMedioTransporteTransitoDirectoDescripcion'].disable();

                this.globalService.getTipoMedioTransporteById(this.IdMedioTransporteTransitoDirecto).subscribe(result => {
                    this.form.patchValue({
                        IdMedioTransporteTransitoDirectoDescripcion: result.Descripcion,
                    });
                });
            }
        }
    }

    private LoadTransbordo(): void {
        if (this.esTransbordo) {
            this.readonlyImporExtr = false;
            if (this.editMode) {
                this.IdMedioTransporteTransbordo = this.solicitud.TwTransbordo.IdMedioTransporteTransbordo!;
                this.IdTipoTransbordo = this.solicitud.TwTransbordo.IdTipoTransbordo!;
                this.IdPuntoInspeccionTransbordo = this.solicitud.TwTransbordo.IdPuntoInspeccionTransbordo!;
                this.globalService.getTipoMedioTransporteById(this.solicitud.TwTransbordo.IdMedioTransporteTransbordo!).subscribe(res => {
                    this.medioTransporteTransbordo = res;
                });
                this.globalService.getTipoTransbordoById(this.IdTipoTransbordo).subscribe(res => {
                    this.tipoTransbordo = res;
                });
                //si el tipo es 'A PCF UE'
                if (this.IdTipoTransbordo == EnumIdsTwTcTipoTransbordo.ID_A_PCF_UE) {
                    this.solicitudService.getPcfTansbordoById(this.IdPuntoInspeccionTransbordo).subscribe(res => {
                        this.pcfTransbordo = res;
                    });
                }
                this.IdPaisDestino = this.solicitud.TLugarMercancia.IdPaisDestino;

                //this.IdMedioTransporte = this.solicitud.TMedioTransporte.IdMedioTransporte!;
                this.form.patchValue({
                    IdPaisDestino: this.solicitud.TLugarMercancia.IdPaisDestino,
                });
            } else {
                this.form.patchValue({
                    IdPaisDestino: this.paramsNuevaSolicitud!.IdPaisTransbordo,
                    IdMedioTransporteTransbordo: this.paramsNuevaSolicitud!.IdMedioTransporteTransbordo,
                    IdTipoTransbordo: this.paramsNuevaSolicitud!.IdTipoTransbordo,
                    IdPuntoInspeccionTransbordo: this.paramsNuevaSolicitud!.IdPuntoInspeccionTransbordo,
                });
                this.IdPaisDestino = this.paramsNuevaSolicitud!.IdPaisTransbordo;
                this.IdMedioTransporteTransbordo = this.paramsNuevaSolicitud!.IdMedioTransporteTransbordo;
                this.IdTipoTransbordo = this.paramsNuevaSolicitud!.IdTipoTransbordo;
                this.IdPuntoInspeccionTransbordo = this.paramsNuevaSolicitud!.IdPuntoInspeccionTransbordo;
                this.globalService.getTipoMedioTransporteById(this.paramsNuevaSolicitud!.IdMedioTransporteTransbordo).subscribe(res => {
                    this.medioTransporteTransbordo = res;
                    this.form.patchValue({
                        IdMedioTransporteTransbordoDescripcion: res.Descripcion,
                    });
                });
                this.globalService.getTipoTransbordoById(this.IdTipoTransbordo).subscribe(res => {
                    this.tipoTransbordo = res;
                    this.form.patchValue({
                        IdTipoTransbordoDescripcion: res.Descripcion,
                    });
                });
                //si el tipo es 'A PCF UE'
                if (this.IdTipoTransbordo == EnumIdsTwTcTipoTransbordo.ID_A_PCF_UE) {
                    this.solicitudService.getPcfTansbordoById(this.IdPuntoInspeccionTransbordo).subscribe(res => {
                        this.pcfTransbordo = res;
                        this.form.patchValue({
                            IdPuntoInspeccionTransbordoDescripcion: res.PcfTracesLocalidad,
                        });
                    });
                }

                this.form.controls['IdPaisDestino'].disable();
                this.form.controls['IdMedioTransporteTransbordoDescripcion'].disable();
                this.form.controls['IdTipoTransbordoDescripcion'].disable();
                this.form.controls['IdPuntoInspeccionTransbordoDescripcion'].disable();
            }
        }
    }

    private createForm(): void {
        this.form = this.fb.group({
            Codigo: null,
            CodigoTraces: null,
            FechaEnvio: null,
            HoraEnvio: null,
            FechaPresentacion: null,
            IdPaisExportador: [null, Validators.required],
            IdTipoSolicitud: this.paramsNuevaSolicitud != null ? this.paramsNuevaSolicitud!.IdTipoSolicitud : null,
            IdSubTipoSolicitud: this.paramsNuevaSolicitud != null ? this.paramsNuevaSolicitud!.IdSubTipoSolicitud : null,
            IdEstadoSolicitud: EnumIdsTcEstadoSolicitud.ID_BORRADOR, //ES EL ESTADO INICIAL POR DEFECTO
            IdPuntoInspeccion: [null, Validators.required],
            //ApellidosInspector: '',
            //NombreInspector: '',
            NombreExportador: ['', Validators.required],
            CiudadExportador: ['', Validators.required],
            DireccionExportador: ['', Validators.required],
            //IdTipoAsignacion: 0,
            Mrn: null,
            EsPredua: this.paramsNuevaSolicitud != null ? this.paramsNuevaSolicitud!.esPredua : null,
            RefSolicitante: '',
            RazonSocial: '',
            NumeroTelefono: '',
            NifSolicitante: '',
            RazonSocialSolicitanteAdministrativo: '',
            NifSolicitanteAdministrativo: '',
            NumeroTelefonoSolicitanteAdministrativo: '',
            IdPaisOrigen: [null, Validators.required],
            IdPaisProcedencia: [null, Validators.required],
            IdPaisDestino: [null, Validators.required],
            IdAduana: null,
            IdUbicacion: [null, Validators.required],
            FechaInspeccion: ['', Validators.required],
            IdIntervaloHoras: null,
            IdMedioTransporte: [null, Validators.required],
            NumeroDeclaracionSumaria: [null, Validators.required],
            NumeroOMI: [null, Validators.required],
            FechaLlegada: ['', Validators.required],
            FechaRecuperacion: '',
            IdPaisTrasladoDescripcion: '',
            PuntoControlPopup: '',
            IdAutoridadControl: null,
            IdAutoridadControlDescripcion: null,
            FechaRegistro: '',
            NRegistroPapel: '',

            //exportador
            CodigoPostalExportador: ['', Validators.required],

            //medio transporte
            IdPaisMedioTransporte: null,
            IdMedioTransporteTrasladoDescripcion: null,
            IdMedioTransporteTransitoDirectoDescripcion: null,
            IdMedioTransporteTransbordoDescripcion: null,
            IdTipoTransbordoDescripcion: null,
            IdPuntoInspeccionTransbordoDescripcion: null,
        });
    } // Fin createForm

    updateForm(): void {
        this.form.setValue({
            Codigo: this.solicitud.Codigo,
            CodigoTraces: this.solicitud.TwTraces != null ? this.solicitud.TwTraces.Codigo : null,
            FechaEnvio: this.datepipe.transform(this.solicitud.FechaEnvio, 'dd/MM/yyyy'),
            HoraEnvio: this.solicitud.HoraEnvio,
            FechaPresentacion: this.datepipe.transform(this.solicitud.FechaPresentacion, 'dd/MM/yyyy'),
            IdPaisExportador: this.solicitud.TExportador.IdPaisExportador,
            IdTipoSolicitud: this.solicitud.IdTipoSolicitud,
            IdSubTipoSolicitud: this.solicitud.IdSubTipoSolicitud,
            IdEstadoSolicitud: this.solicitud.IdEstadoSolicitud,
            IdPuntoInspeccion: this.solicitud.IdPuntoInspeccion,
            NombreExportador: this.solicitud.TExportador.NombreExportador,
            CiudadExportador: this.solicitud.TExportador.CiudadExportador,
            DireccionExportador: this.solicitud.TExportador.DireccionExportador,
            CodigoPostalExportador: this.solicitud.TExportador.CodigoPostalExportador,

            Mrn: this.solicitud.TMedioTransporte.Mrn,
            EsPredua: this.solicitud.TwTcSubTipoSolicitud != null ? this.solicitud.TwTcSubTipoSolicitud.EsPreDua : false,
            RefSolicitante: this.solicitud.RefSolicitante,
            RazonSocial: this.solicitud.TwUsuarioExterno != null ? this.solicitud.TwUsuarioExterno.RazonSocial : null,
            NifSolicitante: this.solicitud.TwUsuarioExterno != null ? this.solicitud.TwUsuarioExterno.NifCifRazonSocial : null,
            NumeroTelefono: this.solicitud.TwUsuarioExterno != null ? this.solicitud.TwUsuarioExterno.NumeroTelefono : null,
            RazonSocialSolicitanteAdministrativo:
                this.solicitud.TSolicitanteAdministrativo != null ? this.solicitud.TSolicitanteAdministrativo.RazonSocialSolicitanteAdministrativo : null,
            NifSolicitanteAdministrativo:
                this.solicitud.TSolicitanteAdministrativo != null ? this.solicitud.TSolicitanteAdministrativo.NifSolicitanteAdministrativo : null,
            NumeroTelefonoSolicitanteAdministrativo:
                this.solicitud.TSolicitanteAdministrativo != null ? this.solicitud.TSolicitanteAdministrativo.NumeroTelefonoSolicitanteAdministrativo : null,

            IdPaisOrigen: this.solicitud.TLugarMercancia.IdPaisOrigen,
            IdPaisProcedencia: this.solicitud.TLugarMercancia.IdPaisProcedencia,
            IdPaisDestino: this.solicitud.TLugarMercancia.IdPaisDestino,
            IdAduana: this.solicitud.TLugarMercancia.IdAduana,
            IdUbicacion: this.solicitud.TLugarMercancia.IdUbicacion,
            FechaInspeccion: this.solicitud.TLugarMercancia.FechaInspeccion != null ? new Date(this.solicitud.TLugarMercancia.FechaInspeccion) : null,
            IdIntervaloHoras: this.solicitud.TLugarMercancia.IdIntervaloHoras,

            IdMedioTransporte: this.solicitud.TMedioTransporte.IdMedioTransporte,
            NumeroDeclaracionSumaria: this.solicitud.TMedioTransporte.NumeroDeclaracionSumaria,
            NumeroOMI: this.solicitud.TMedioTransporte.NumeroOMI,
            FechaLlegada: this.solicitud.TMedioTransporte.FechaLlegada != null ? new Date(this.solicitud.TMedioTransporte.FechaLlegada) : '',
            FechaRecuperacion:
                this.solicitud.TMedioTransporte.FechaRecuperacionMrn != null ? new Date(this.solicitud.TMedioTransporte.FechaRecuperacionMrn) : '',
            IdPaisMedioTransporte: this.solicitud.TMedioTransporte.IdPaisMedioTransporte,

            IdPaisTrasladoDescripcion: this.solicitud.TwTraslado != null ? this.solicitud.TwTraslado.IdPaisTrasladoDescripcion : '',

            IdAutoridadControl: this.solicitud.TwTraslado != null ? this.solicitud.TwTraslado.IdAutoridadControl : null,
            IdAutoridadControlDescripcion: this.solicitud.TwTraslado != null ? this.solicitud.TwTraslado.IdAutoridadControlDescripcion : '',

            PuntoControlPopup:
                this.solicitud.TwTraslado != null
                    ? this.solicitud.TwTraslado.IdPuntoControlTrasladoDescripcion + ' - ' + this.solicitud.TwTraslado.IdPuntoControlTrasladoLocalidad
                    : null,
            IdMedioTransporteTrasladoDescripcion: this.solicitud.TwTraslado != null ? this.solicitud.TwTraslado.IdMedioTransporteTrasladoDescripcion : null,

            IdMedioTransporteTransitoDirectoDescripcion:
                this.solicitud.TwTransitoDirecto != null ? this.solicitud.TwTransitoDirecto.IdMedioTransporteTransitoDirectoDescripcion : null,

            IdMedioTransporteTransbordoDescripcion:
                this.solicitud.TwTransbordo != null ? this.solicitud.TwTransbordo.IdMedioTransporteTransbordoDescripcion : null,

            IdTipoTransbordoDescripcion: this.solicitud.TwTransbordo != null ? this.solicitud.TwTransbordo.IdTipoTransbordoDescripcion : null,

            IdPuntoInspeccionTransbordoDescripcion:
                this.solicitud.TwTransbordo != null ? this.solicitud.TwTransbordo.IdPuntoInspeccionTransbordoDescripcion : null,

            FechaRegistro:
                this.solicitud.TSolicitudAdministrativo != null && this.solicitud.TSolicitudAdministrativo.FechaRegistro != null
                    ? new Date(this.solicitud.TSolicitudAdministrativo.FechaRegistro)
                    : '',
            NRegistroPapel: this.solicitud.TSolicitudAdministrativo != null ? this.solicitud.TSolicitudAdministrativo.NRegistroPapel : null,
        });

        this.solicitudEnviada = this.solicitud.Codigo != null;

        if (
            !this.esPredua &&
            ((this.esPrevia && this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA && this.enviada) ||
                (this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_BORRADOR && this.enviada) ||
                (this.esClonada && !this.enviada && !this.esPrevia))
        ) {
            //Actualizo validaciones del documento aduanero
            this.UpdateDocumentoAduanero(this.solicitud.IdPuntoInspeccion);
        }

        //PAIS MEDIO TRANSPORTE
        if (this.paisRequiredMedioTransporte) {
            this.addValidator('IdPaisMedioTransporte', Validators.required);
        } else {
            this.removeValidators('IdPaisMedioTransporte');
        }

        //hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al
        //valor de ciertas columnas al seleccionar un elemento
        this.globalService.getAllPaisesTcUsaCodigoPostal().subscribe(res => {
            this.listPais = res;

            if (!(this.esPrevia && this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA && !this.enviada)) {
                //PAIS EXPORTADOR
                const idPaisExportador = this.form.controls['IdPaisExportador'].value; //this.form.value.IdPaisExportador;
                let seleccionado = this.listPais?.find(x => x.Id == idPaisExportador);
                if (seleccionado != null) {
                    this.usaCodigoPostalPaisExportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
                } else {
                    this.usaCodigoPostalPaisExportador = true; //RDLF: por defecto que sea obligatorio, por problemas con las de Canarias CF PREDUA
                }
                if (this.usaCodigoPostalPaisExportador!.valueOf() == true) {
                    this.addValidator('CodigoPostalExportador', Validators.required);
                } else {
                    this.removeValidators('CodigoPostalExportador');
                }
            }
        });
    } // Fin updateForm

    onSaveSolicitud(): void {
        this.visibilitySpinnerGuardar = true;
        this.onSubmit();
    }

    onSubmit(): void {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos de la solicitud');

            this.isCollapsedCabecera = false;
            this.isCollapsedExportador = false;
            this.isCollapsedTraslado = false;
            this.isCollapsedTransitoDirecto = false;
            this.isCollapsedSolicitante = false;
            this.isCollapsedSolicitanteAdministrativo = false;
            this.isCollapsedLugaresMercancia = false;
            this.isCollapsedMediosTransporte = false;
            this.isCollapsedDatosEnvio = false;
            this.isCollapsedDatosPapel = false;

            this.visibilitySpinnerGuardar = false;

            return;
        }

        let solicitudVM = new SolicitudViewModel();

        solicitudVM.IdTipoSolicitud = this.form.value.IdTipoSolicitud;
        solicitudVM.IdSubTipoSolicitud = this.form.value.IdSubTipoSolicitud;
        solicitudVM.Codigo = this.form.value.Codigo;
        solicitudVM.IdPuntoInspeccion = this.form.controls.IdPuntoInspeccion.value;
        solicitudVM.RefSolicitante = this.form.value.RefSolicitante;
        solicitudVM.IdUsuarioSolicitante = this.IdSolicitante;

        if (this.solicitud.FechaCreacion != null) {
            solicitudVM.FechaCreacion = this.solicitud.FechaCreacion;
        }

        solicitudVM.TExportador.NombreExportador = this.form.value.NombreExportador;
        solicitudVM.TExportador.IdPaisExportador = this.form.value.IdPaisExportador;
        solicitudVM.TExportador.CiudadExportador = this.form.value.CiudadExportador;
        solicitudVM.TExportador.DireccionExportador = this.form.value.DireccionExportador;
        solicitudVM.TExportador.CodigoPostalExportador = this.form.value.CodigoPostalExportador;

        //Si guardamos correctamente una Previa Aceptada pasa a ser 'Borrador'
        if (this.form.value.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA) {
            solicitudVM.IdEstadoSolicitud = EnumIdsTcEstadoSolicitud.ID_BORRADOR;
        } else {
            solicitudVM.IdEstadoSolicitud = this.form.value.IdEstadoSolicitud;
        }

        solicitudVM.TLugarMercancia.IdPaisOrigen = this.form.value.IdPaisOrigen;

        if (this.esCanarias) {
            solicitudVM.TLugarMercancia.IdPaisProcedencia = EnumIdsTcPais.ID_ESPANA;
        } else {
            solicitudVM.TLugarMercancia.IdPaisProcedencia = this.form.value.IdPaisProcedencia;
        }

        if (!this.esTransitoDirecto && !this.esTransbordo) {
            solicitudVM.TLugarMercancia.IdPaisDestino = this.form.value.IdPaisDestino;
        } else {
            solicitudVM.TLugarMercancia.IdPaisDestino = this.IdPaisDestino;
        }

        solicitudVM.TLugarMercancia.IdAduana = this.form.value.IdAduana;
        solicitudVM.TLugarMercancia.IdUbicacion = this.form.value.IdUbicacion;
        solicitudVM.TLugarMercancia.FechaInspeccion = this.form.value.FechaInspeccion;
        solicitudVM.TLugarMercancia.IdIntervaloHoras = this.form.value.IdIntervaloHoras;

        solicitudVM.TMedioTransporte.IdMedioTransporte = this.form.value.IdMedioTransporte;
        solicitudVM.TMedioTransporte.NumeroOMI = this.form.value.NumeroOMI;
        solicitudVM.TMedioTransporte.FechaLlegada = this.form.value.FechaLlegada;

        // Si es solicitud de tipo 'Pasajeros', se le añade por defecto el texto "Sin REF Aduanera"
        if (solicitudVM.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_PASAJEROS) {
            solicitudVM.TMedioTransporte.NumeroDeclaracionSumaria = this.declaracionSumariaPasajeros;
        } else {
            solicitudVM.TMedioTransporte.NumeroDeclaracionSumaria = this.form.value.NumeroDeclaracionSumaria;
        }
        solicitudVM.TMedioTransporte.IdPaisMedioTransporte = this.form.value.IdPaisMedioTransporte;
        solicitudVM.TMedioTransporte.Mrn = this.form.value.Mrn;

        //Porque falla con el pif si no es un MRN validado.
        //if (this.esPredua) {
        //    solicitud.IdPuntoInspeccion = this.IdPuntoInspeccion!; // this.form.value.IdPuntoInspeccion;
        //}

        solicitudVM.EsExtranjero = this.esImportadorExtranjero;
        solicitudVM.EsPrevia = this.esPrevia;
        solicitudVM.EsReImportacion = this.esReImportacion;
        //El Formato por defecto es 'Aplicacion'
        solicitudVM.IdFormatoSolicitud = 1;

        //SOLICITUD GRABADOR
        if (this.esSolicitudGrabador) {
            //Si es grabador es Formato 'Papel'
            solicitudVM.IdFormatoSolicitud = 2;

            solicitudVM.IdUsuarioSolicitanteAdministrativo = this.IdSolicitanteAdministrativo;

            solicitudVM.TSolicitudAdministrativo = new TSolicitudAdministrativoViewModel();
            solicitudVM.TSolicitudAdministrativo.IdUsuarioGrabador = this.IdGrabador!;
            solicitudVM.TSolicitudAdministrativo.FechaRegistro = this.form.value.FechaRegistro;
            solicitudVM.TSolicitudAdministrativo.NRegistroPapel = this.form.value.NRegistroPapel;

            solicitudVM.TSolicitanteAdministrativo = new TSolicitanteAdministrativoViewModel();
            solicitudVM.TSolicitanteAdministrativo.Id = this.IdSolicitanteAdministrativo!;
            solicitudVM.TSolicitanteAdministrativo.NifSolicitanteAdministrativo = this.form.value.NifSolicitanteAdministrativo;
            solicitudVM.TSolicitanteAdministrativo.RazonSocialSolicitanteAdministrativo = this.form.value.RazonSocialSolicitanteAdministrativo;
            solicitudVM.TSolicitanteAdministrativo.NumeroTelefonoSolicitanteAdministrativo = this.form.value.NumeroTelefonoSolicitanteAdministrativo;
        }

        //FINES CIENTIFICOS
        if (solicitudVM.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_FINES_CIENTIFICOS && this.solicitud.FechaCartaAutorizacion == null) {
            solicitudVM.FechaCartaAutorizacion = this.paramsNuevaSolicitud!.FechaCartaAutorizacion;
            //solicitud.OrganismosCB = this.solicitudService.currentParamNuevaSolicitud.Ocb;
        }

        //TRASLADO
        if (this.esTraslado) {
            solicitudVM.TwTraslado = new TwTrasladoViewModel();
            solicitudVM.TwTraslado.IdPaisTraslado = this.IdPaisTraslado;
            solicitudVM.TwTraslado.IdPuntoControlTraslado = this.IdPuntoControl;
            solicitudVM.TwTraslado.IdMedioTransporteTraslado = this.IdMedioTransporteTraslado;
            solicitudVM.TwTraslado.IdAutoridadControl = this.form.value.IdAutoridadControl; //this.IdAutoridadControl;
        }

        //TRANSITO DIRECTO
        if (this.esTransitoDirecto) {
            solicitudVM.TwTransitoDirecto = new TwTransitoDirectoViewModel();
            solicitudVM.TwTransitoDirecto.IdMedioTransporteTransitoDirecto = this.IdMedioTransporteTransitoDirecto;
        }
        //TRANSBORDO
        if (this.esTransbordo) {
            solicitudVM.TwTransbordo = new TwTransbordoViewModel();
            solicitudVM.TwTransbordo.IdMedioTransporteTransbordo = this.IdMedioTransporteTransbordo;
            solicitudVM.TwTransbordo.IdTipoTransbordo = this.IdTipoTransbordo;
            if (this.IdTipoTransbordo == EnumIdsTwTcTipoTransbordo.ID_A_PCF_UE) {
                solicitudVM.TwTransbordo.IdPuntoInspeccionTransbordo = this.IdPuntoInspeccionTransbordo;
            }
        }

        solicitudVM.Id = this.solicitud.Id;

        if (this.editMode) {
            // Si el Solicitante cambia el PCF de uno canario a uno peninsular, o al revés, debemos informarle de que se eliminarán los datos asociados al Importador y al Lugar de Destino
            let idPCF: number;
            if (this.form.value.IdPuntoInspeccion) {
                idPCF = this.form.value.IdPuntoInspeccion;
            } else {
                idPCF = solicitudVM.IdPuntoInspeccion;
            }
            // Lista de Ids (TPuntoInspeccion) correspondientes a las Islas Canarias
            const idsPCFsCanariasList = [28, 29, 30, 31, 32, 33, 612, 613, 614, 615, 616, 617, 618, 619];

            let tienePCFCanario = false;
            let tienePCFPeninsular = false;

            if (idsPCFsCanariasList.includes(this.solicitud.IdPuntoInspeccion)) {
                tienePCFCanario = true;
            } else {
                tienePCFPeninsular = true;
            }

            if (
                this.solicitud.TImportador?.Nif != null &&
                this.solicitud.TImportador?.Nif != '' &&
                this.solicitud.TImportador?.Nif != undefined &&
                ((tienePCFCanario && !idsPCFsCanariasList.includes(idPCF)) || (tienePCFPeninsular && idsPCFsCanariasList.includes(idPCF)))
            ) {
                this.confirmationService.confirm({
                    message:
                        '¿Está seguro? Si modifica el Punto de Inspección, y este cambia de uno canario a uno peninsular o viceversa, se borrarán todos los datos asociados al Importador y al Lugar de Destino',
                    accept: () => {
                        solicitudVM.DeleteTImportadorYTImportadorLugarDestino = true;
                        this.editSolicitud(solicitudVM);
                    },
                    reject: () => {
                        this.visibilitySpinnerGuardar = false;
                    },
                });
            } else {
                if (this.solicitud.TImportador?.Nif == null || this.solicitud.TImportador?.Nif == undefined || this.solicitud.TImportador?.Nif == '') {
                    solicitudVM.DeleteTImportadorYTImportadorLugarDestino = true;
                }
                this.editSolicitud(solicitudVM);
            }
        } else {
            this.solicitudService.createSolicitud(solicitudVM).subscribe({
                next: res => {
                    this.visibilitySpinnerGuardar = false;
                    this.addSuccessMessage('Solicitud creada correctamente');
                    let idSolicitud = res;
                    this.router.navigate(['/importacion/solicitud/datosbasicos/' + idSolicitud]);
                    //this.onBack();
                },
                error: error => {
                    this.visibilitySpinnerGuardar = false;
                    this.catchServerError(error);

                    this.isCollapsedCabecera = false;
                    this.isCollapsedExportador = false;
                    this.isCollapsedTraslado = false;
                    this.isCollapsedTransitoDirecto = false;
                    this.isCollapsedSolicitante = false;
                    this.isCollapsedSolicitanteAdministrativo = false;
                    this.isCollapsedLugaresMercancia = false;
                    this.isCollapsedMediosTransporte = false;
                    this.isCollapsedDatosEnvio = false;
                    this.isCollapsedDatosPapel = false;
                },
            });
        }
    }

    private editSolicitud(solicitud: SolicitudViewModel) {
        this.solicitudService.editSolicitud(solicitud).subscribe({
            next: () => {
                this.visibilitySpinnerGuardar = false;
                this.addSuccessMessage('Solicitud modificada correctamente');

                //Para forzar a refrescar el estado
                if (
                    this.form.value.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA ||
                    this.esClonada ||
                    this.esClonFinalizaTraslado ||
                    this.esParticionRp ||
                    this.solicitanteCambiandoPIF
                ) {
                    this.form.controls['IdPuntoInspeccion'].disable();
                    this.form.controls['IdUbicacion'].disable();
                    this.solicitanteCambiandoPIF = false;
                    this.ngOnInit();
                }
            },
            error: error => {
                this.visibilitySpinnerGuardar = false;
                this.catchServerError(error);

                this.isCollapsedCabecera = false;
                this.isCollapsedExportador = false;
                this.isCollapsedTraslado = false;
                this.isCollapsedTransitoDirecto = false;
                this.isCollapsedSolicitante = false;
                this.isCollapsedSolicitanteAdministrativo = false;
                this.isCollapsedLugaresMercancia = false;
                this.isCollapsedMediosTransporte = false;
                this.isCollapsedDatosEnvio = false;
                this.isCollapsedDatosPapel = false;
            },
        });
    }

    onSelectPuntoInspeccion(): void {
        //si el punto de inspección es nulo no hacemos nada
        if (this.IdPuntoInspeccion! == null && this.form.value.IdPuntoInspeccion == null) {
            this.form.patchValue({
                IdUbicacion: null,
                IdAduana: null,
                IdIntervaloHoras: null,
                NumeroDeclaracionSumaria: null,
            });
            this.listUbicacion = [];
            this.listAduana = [];
            this.listIntervalo = [];
            return;
        }

        let idPuntoInspeccion;

        if (this.editMode && !this.solicitanteCambiandoPIF) {
            idPuntoInspeccion = this.solicitud.IdPuntoInspeccion;
        } else if (this.solicitanteCambiandoPIF) {
            if (this.form.value.IdPuntoInspeccion !== null) {
                idPuntoInspeccion = this.form.value.IdPuntoInspeccion;

                let params = new HttpParams();
                params = params.append('id', idPuntoInspeccion.toString());
                params = params.append('esimportacion', 'true');
                this.globalService.getUbicacionByPuntoInspeccion(params).subscribe(res => {
                    this.listUbicacion = res;
                });
                this.globalService.getAduanaByPuntoInspeccion(idPuntoInspeccion).subscribe(res => {
                    this.listAduana = res;
                });
                this.globalService.getIntervaloHorasByPuntoInspeccion(idPuntoInspeccion).subscribe(res => {
                    this.listIntervalo = res;
                });

                this.form.patchValue({
                    IdUbicacion: null,
                    IdAduana: null,
                    IdIntervaloHoras: null,
                    NumeroDeclaracionSumaria: null,
                });
            } else {
                return;
            }
        } else {
            idPuntoInspeccion = this.IdPuntoInspeccion! != null ? this.IdPuntoInspeccion! : this.form.value.IdPuntoInspeccion;

            let params = new HttpParams();
            params = params.append('id', idPuntoInspeccion.toString());
            params = params.append('esimportacion', 'true');
            this.globalService.getUbicacionByPuntoInspeccion(params).subscribe(res => {
                this.listUbicacion = res;
            });
            this.globalService.getAduanaByPuntoInspeccion(idPuntoInspeccion).subscribe(res => {
                this.listAduana = res;
            });
            this.globalService.getIntervaloHorasByPuntoInspeccion(idPuntoInspeccion).subscribe(res => {
                this.listIntervalo = res;
            });

            this.form.patchValue({
                IdUbicacion: null,
                IdAduana: null,
                IdIntervaloHoras: null,
                NumeroDeclaracionSumaria: null,
            });
        }

        if (!this.esPredua && !this.esPrevia) {
            //ACTUALIZO VALIDACIONES DE DOCUMENTO ADUANERO
            this.UpdateDocumentoAduanero(idPuntoInspeccion);
        } else {
            this.GestionTipoPif(idPuntoInspeccion);
        }
    }

    onChangePuntoInspeccion(): void {
        this.confirmationService.confirm({
            message: '¿Está seguro? Se borrarán todos los datos asociados al Punto de Inspección.',
            accept: () => {
                this.form.patchValue({
                    IdPuntoInspeccion: null,
                    IdUbicacion: null,
                    IdAduana: null,
                    IdIntervaloHoras: null,
                    NumeroDeclaracionSumaria: null,
                });
                //Si es de tipo Pasajeros, Trasbordo, Traslado o Tránsito
                if (
                    this.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_PASAJEROS ||
                    this.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRANSBORDO ||
                    this.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRASLADO ||
                    this.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRANSITO_DIRECTO
                ) {
                    let params = new HttpParams();

                    params = params.append('idpais', EnumIdsTcPais.ID_ESPANA.toString());
                    params = params.append('esgrabador', this.esGrabador.toString());
                    params = params.append('idusuario', this.loggedInUser!.Id.toString());
                    //PIFs sin Canarias
                    this.solicitudService.getPuntoInspeccionImportacionSinCanarias(params).subscribe(res => {
                        this.listPuntoInspeccion = res;
                    });
                }
                this.listUbicacion = [];
                this.listAduana = [];
                this.listIntervalo = [];

                this.solicitanteCambiandoPIF = true;

                this.form.controls['IdPuntoInspeccion'].enable();
            },
        });
    }

    onSelectTipoMedioTransporte(): void {
        //Si es previa no se valida nada
        if (!this.esPrevia && !(this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA && this.enviada)) {
            this.paisRequiredMedioTransporte = this.form.value.IdMedioTransporte == EnumIdsTcTipoMedioTransporte.ID_AVION ? false : true;

            if (this.paisRequiredMedioTransporte) {
                this.addValidator('IdPaisMedioTransporte', Validators.required);
            } else {
                this.removeValidators('IdPaisMedioTransporte');
            }
        }
    }

    onSelectPaisExportador(): void {
        const idPais = this.form.controls['IdPaisExportador'].value; //this.form.value.IdPaisExportador;

        let seleccionado = this.listPais?.find(x => x.Id == idPais);

        if (seleccionado != null) {
            this.usaCodigoPostalPaisExportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
        }

        if (this.usaCodigoPostalPaisExportador!.valueOf() == true) {
            this.addValidator('CodigoPostalExportador', Validators.required);
        } else {
            this.removeValidators('CodigoPostalExportador');
        }
    }

    private UpdateDocumentoAduanero(idPuntoInspeccion: any): void {
        this.removeValidators('NumeroDeclaracionSumaria');
        this.puntoInspeccionService.getPuntoInspeccion(idPuntoInspeccion).subscribe(result => {
            this.IdTipoPuntoInspeccion = result.IdTipoPuntoInspeccion;
            if (result.IdTipoPuntoInspeccion == EnumIdsTcTipoPuntoInspeccion.ID_AEROPUERTO) {
                this.addValidator('NumeroDeclaracionSumaria', Validators.required);
                this.addValidator('NumeroDeclaracionSumaria', Validators.minLength(18));
                this.addValidator('NumeroDeclaracionSumaria', Validators.maxLength(this.DEC_SUMARIA_AEROPUERTO));
                this.esAeropuerto = true;
                this.maxlenghtDecSumaria = this.DEC_SUMARIA_AEROPUERTO;
            } else {
                this.addValidator('NumeroDeclaracionSumaria', Validators.required);
                this.addValidator('NumeroDeclaracionSumaria', Validators.minLength(this.DEC_SUMARIA_PUERTO));
                this.addValidator('NumeroDeclaracionSumaria', Validators.maxLength(this.DEC_SUMARIA_PUERTO));
                this.esAeropuerto = false;
                this.maxlenghtDecSumaria = this.DEC_SUMARIA_PUERTO;
            }

            this.EstableceMedioTransporte(this.IdTipoPuntoInspeccion);
        });
    }

    private GestionTipoPif(idPuntoInspeccion: any): void {
        this.puntoInspeccionService.getPuntoInspeccion(idPuntoInspeccion).subscribe(result => {
            this.IdTipoPuntoInspeccion = result.IdTipoPuntoInspeccion;
            if (result.IdTipoPuntoInspeccion == EnumIdsTcTipoPuntoInspeccion.ID_AEROPUERTO) {
                this.esAeropuerto = true;
            } else {
                this.esAeropuerto = false;
            }
        });
    }

    onContrastarPredua(): void {
        if (this.form.value.Mrn != null && this.form.value.Mrn != '') {
            this.loadPreduaDatos(this.form.value.Mrn);
        }
    }

    onSearchNifSolicitanteAdministrativo(): void {
        if (
            this.form.controls.NifSolicitanteAdministrativo.valid &&
            this.form.value.NifSolicitanteAdministrativo != null &&
            this.form.value.NifSolicitanteAdministrativo != ''
        ) {
            this.solicitudService.getSolicitanteAdministrativo(this.form.value.NifSolicitanteAdministrativo).subscribe(s => {
                if (s != null) {
                    this.form.patchValue({
                        RazonSocialSolicitanteAdministrativo: s.RazonSocialSolicitanteAdministrativo,
                        NumeroTelefonoSolicitanteAdministrativo: s.NumeroTelefonoSolicitanteAdministrativo,
                    });
                    this.IdSolicitanteAdministrativo = s.Id;
                    this.habilitarSolicitanteAdministrativo = false;
                } else {
                    this.IdSolicitanteAdministrativo = 0;
                    this.addInfoMessage('No se encontró el NIF, introduzca los datos del solicitante.');
                    this.habilitarSolicitanteAdministrativo = true;
                }
            });
        } else {
            this.form.patchValue({
                RazonSocialSolicitanteAdministrativo: '',
                NumeroTelefonoSolicitanteAdministrativo: '',
            });
        }
    }

    private loadPreduaDatos(mrn: string): void {
        this.solicitudService.getDatosPredua(mrn).subscribe(s => {
            if (s != null) {
                if (s.IdPaisDestino !== null) {
                    this.IdPaisDestino = s.IdPaisDestino;
                    this.form.patchValue({
                        IdPaisDestino: s.IdPaisDestino,
                    });
                }

                this.form.patchValue({
                    IdPuntoInspeccion: s.IdPif,
                    NombreExportador: s.NombreExportador,
                    IdPaisExportador: s.IdPaisExportador,
                    CiudadExportador: s.CiudadExportador,
                    DireccionExportador: s.DireccionExportador,
                    //RDLF: para los PREDUAS no precargar datos de importador (101338), dicho por Tomás (02/11/2023)
                    //NIF: s.IdentificadorImportador,
                    //Nombre: s.RazonSocialImportador,
                    //Direccion: s.DireccionImportador,
                    IdPaisOrigen: s.IdPaisOrigen,
                    //IdPaisDestino: s.IdPaisDestino,
                    IdAduana: s.IdAduanaDespacho,
                    IdMedioTransporte: s.IdMedioTransporte,
                    Mrn: s.Mrn,
                    FechaRecuperacion: new Date(),
                });

                this.deshabilitarMrn = true;
                this.IdPuntoInspeccion = s.IdPif;
                this.isCanariasPifCanarias = this.esCanarias && s.IsPifCanarias;

                //Compruebo que el PIF esté Activo
                this.puntoInspeccionService.getPuntoInspeccion(this.IdPuntoInspeccion).subscribe(result => {
                    if (result.Activo) {
                        //Cargo las colecciones ya que el IdPuntoInspeccion me viene cargado y no se hace el 'onSelect'

                        let params = new HttpParams();
                        params = params.append('id', this.IdPuntoInspeccion!.toString());
                        params = params.append('esimportacion', 'true');
                        this.globalService.getUbicacionByPuntoInspeccion(params).subscribe(res => {
                            this.listUbicacion = res;
                        });
                        this.globalService.getAduanaByPuntoInspeccion(this.IdPuntoInspeccion!).subscribe(res => {
                            this.listAduana = res;
                        });
                        this.globalService.getIntervaloHorasByPuntoInspeccion(this.IdPuntoInspeccion!).subscribe(res => {
                            this.listIntervalo = res;
                        });
                        //PAIS MEDIO TRANSPORTE
                        this.paisRequiredMedioTransporte = this.form.value.IdMedioTransporte == EnumIdsTcTipoMedioTransporte.ID_AVION ? false : true;
                        if (this.paisRequiredMedioTransporte) {
                            this.addValidator('IdPaisMedioTransporte', Validators.required);
                        } else {
                            this.removeValidators('IdPaisMedioTransporte');
                        }

                        //vuelvo a hacer update para las solicitudes Canarias CF PREDUA, cuando ya ha sido grabada por el solicitante
                        if (
                            this.esPredua &&
                            this.solicitud.TwTcSubTipoSolicitud.EsConCf &&
                            this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_BORRADOR &&
                            //RDLF: temporalmente para controlar que ya ha sido guardada por el solicitante
                            this.solicitud.TExportador.NombreExportador != null &&
                            this.solicitud.TMedioTransporte.IdMedioTransporte != null &&
                            this.solicitud.TLugarMercancia.IdPaisOrigen != null
                        ) {
                            this.updateForm();
                        }
                    }
                    //Si no está Activo no se cargan los datos
                    else {
                        //this.confirmationService.confirm({
                        //    message: 'El Punto de Inspección no se encuentra activo',
                        //    rejectVisible: false,
                        //    acceptLabel: 'OK',
                        //    header: 'Error en la carga de datos',
                        //    icon: 'fa fa-home'

                        //})
                        this.addErrorMessage('El Punto de Inspección no se encuentra activo');
                        //Deshabilito los controles
                        this.DisableControlsConsulta();
                        this.habilitarGuardar = false;
                    }
                });
            }
            //Muestro ventana de confirmación de MRN no encontrado
            else {
                //Habilito el campo Mrn para que puedan cargar otro correcto
                this.deshabilitarMrn = false;
                this.addInfoMessage('El MRN no se encuentra en la base de datos');

                //Si es de tipo Pasajeros, Trasbordo, Traslado o Tránsito
                if (
                    this.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_PASAJEROS ||
                    this.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRANSBORDO ||
                    this.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRASLADO ||
                    this.IdTipoSolicitud == EnumIdsTcTipoSolicitud.ID_TRANSITO_DIRECTO
                ) {
                    let params = new HttpParams();

                    params = params.append('idpais', EnumIdsTcPais.ID_ESPANA.toString());
                    params = params.append('esgrabador', this.esGrabador.toString());
                    params = params.append('idusuario', this.loggedInUser!.Id.toString());
                    //PIFs sin Canarias
                    this.solicitudService.getPuntoInspeccionImportacionSinCanarias(params).subscribe(res => {
                        this.listPuntoInspeccion = res;
                    });
                }

                this.form.controls['IdPuntoInspeccion'].enable();
            }
        });
    }

    onSearchPuntoControl(): void {
        if (this.habilitarGuardar) {
            this.puntoControlPopupComponent.showDialog(this.IdPaisTraslado, null);
        } else {
            //Mostrar datos para consulta
            this.puntoControlPopupComponent.showDialog(null, this.solicitud.TwTraslado.IdPuntoControlTraslado);
        }
    }

    onAceptDialogPuntoControl(puntoControl: PuntoControlViewModel): void {
        this.infoPuntoControl = puntoControl.Descripcion + ' - ' + puntoControl.Localidad;
        this.IdPuntoControl = puntoControl.Id;
        this.form.patchValue({
            PuntoControlPopup: this.infoPuntoControl,
        });
        this.removeValidators('PuntoControlPopup');

        this.puntoControlService.getAutoridadesControlByPuntoControl(puntoControl.Id).subscribe(res => {
            this.listAutoridadControl = res;

            this.addValidator('IdAutoridadControl', Validators.required);

            //Si solo hay una autoridad asociada al punto de control, se precarga (en el 95% de los casos)
            if (this.listAutoridadControl.length == 1) {
                this.form.patchValue({
                    IdAutoridadControl: res[0].Id,
                });

                this.removeValidators('IdAutoridadControl');
            }
        });
    }

    onDetailSolicitante(): void {
        //if (this.editMode) {
        //    this.solicitudService.currentIdSolicitud = this.solicitud.Id;
        //}

        this.router.navigate([this.router.url, 'solicitante', this.IdSolicitante]);
    }

    onBack(): void {
        this.router.navigate(['/importacion/solicitudes']);
    }

    cargarDatosPrueba(): void {
        this.form.patchValue({
            Codigo: null,
            FechaEnvio: '',
            HoraEnvio: null,
            FechaPresentacion: '',
            IdPaisExportador: 149,
            IdTipoSolicitud: this.paramsNuevaSolicitud!.IdTipoSolicitud,
            NombreExportador: 'frutas y verduras s.l.',
            CiudadExportador: 'valencia',
            DireccionExportador: 'GREMI TEIXIDORS,4',
            CodigoPostalExportador: 28080,
            RefSolicitante: 'prueba web',
            NIF: '11111111h',
            NRegistro: '',
            Nombre: '',
            Direccion: '',
            IdPaisOrigen: 12,
            IdPaisProcedencia: 60,
            IdPaisDestino: 14,
            IdAduana: null,
            IdUbicacion: null,
            FechaInspeccion: '',
            IdIntervaloHoras: null,
            NumeroDeclaracionSumaria: '5676756756765765',
            NumeroOMI: 'uty57',
            FechaLlegada: '',
            IdPuntoInspeccionTransito: null,
            //IdPuntoControlTransito: null,
            Localidad: 'Madrid',
            CodigoPostalImportador: 28028,
        });
    }

    onPrintDocumentoDatosSolicitud(): void {
        this.visibilitySpinnerInformeDatos = true;
        this.solicitudService.exportDocumentoDatosSolicitud(this.solicitud.Id).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinnerInformeDatos = false;
        });
    }

    onPrintDocumentoResultadoInspeccion(): void {
        this.visibilitySpinnerInformeInspeccion = true;
        this.solicitudService.exportDocumentoResultadoInspeccion(this.solicitud.Id).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinnerInformeInspeccion = false;
        });
    }

    onPrintInformeChedPPTraces(): void {
        this.visibilitySpinnerInformeChedPPTraces = true;
        this.solicitudService.exportInformeChedPPTraces(this.solicitud.TwTraces.Codigo).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinnerInformeChedPPTraces = false;
        });
    }

    // Se deja éste código como referencia
    //printDocumentoTransito() {
    //    this.visibilitySpinnerInformeTransito = true;
    //    this.solicitudService.exportDocumentoFitoSanitarioTransporte(this.solicitud.Id).subscribe(
    //        (res) => {
    //            this.OpenDownloadedFile(res);
    //            this.visibilitySpinnerInformeTransito = false;
    //        });
    //}

    // Se deja éste código como referencia
    //printCertificadoEx() {
    //    this.solicitudService.exportCertificadoExportCanarias(this.solicitudService.currentParamNuevaSolicitud.NumCertificado, this.solicitudService.currentParamNuevaSolicitud.Pin).subscribe(
    //        (res) => {
    //            this.OpenDownloadedFile(res);
    //        });
    //}
}
